import { makeAutoObservable } from "mobx";

/**
 * Main store for managing global UI state and modal interactions
 * Handles modal alerts, image modal data, and session information tabs
 */
class mainStore {
  /**
   * Initialize the main store
   * Sets up MobX observables for reactive state management
   */
  constructor() {
    makeAutoObservable(this);
  }

  /** @type {Function|null} Modal alert function reference */
  showModalAlert = null;

  /** @type {Object|null} Image modal data object */
  imageModalData = null;

  /** @type {string} Currently selected session information tab */
  sessionInformationSelectedTab = 'session-notes';

  /**
   * Set the modal alert function reference
   * @param {Function} showModalAlert - Function to show modal alerts
   * @returns {void}
   */
  setShowModalAlert(showModalAlert) {
    this.showModalAlert = showModalAlert;
  }

  /**
   * Set image modal data
   * @param {Object} imageModalData - Image data for modal display
   * @returns {void}
   */
  setImageModalData(imageModalData) {
    this.imageModalData = imageModalData;
  }

  /**
   * Set the selected session information tab
   * @param {string} sessionInformationSelectedTab - Tab identifier
   * @returns {void}
   */
  setSessionInformationSelectedTab(sessionInformationSelectedTab) {
    this.sessionInformationSelectedTab = sessionInformationSelectedTab;
  }
}

const MainStore = new mainStore();

export default MainStore;